import { FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { PageContent, PageContentInner } from "../atoms";
import { PageLoader } from "../molecules/PageLoader";
import { MenuBar } from "./MenuBar";

interface LayoutProps {
  isAppLoading: boolean;
}

const Layout: FC<LayoutProps> = ({ isAppLoading }) => {
  if (isAppLoading) {
    return (
      <PageContent>
        <PageLoader size="large" />
      </PageContent>
    );
  }

  return (
    <div>
      <PageContent>
        <MenuBar />
        <PageContentInner>
          <Suspense fallback={<PageLoader size="small" />}>
            <Outlet />
          </Suspense>
        </PageContentInner>
      </PageContent>
    </div>
  );
};

export { Layout };
